import axios from "axios";
import { ListFieldsKeys } from "src/api/config";
import { listMap } from "src/api/config/systemSwitch";
import { strapiUrl } from "src/modules/users/constants";

export const setStrapiItemUserFieldsById = async (
  listName: ListFieldsKeys,
  itemId: number,
  userFields: Record<string, number>,
) => {
  const listStrapiApi = listMap[listName].replace(":folder", "");
  const { data: listData } = await axios.get(
    `${strapiUrl}${listStrapiApi}?filters[id][$eq]=${itemId}`,
    { withCredentials: true },
  );
  const documentId = listData?.data?.[0]?.documentId;

  if (!documentId) {
    throw new Error(`Missing documentId for ${listName} item ${itemId}`);
  }

  return axios.put(
    `${strapiUrl}${listStrapiApi}/${documentId}`,
    { data: userFields },
    { withCredentials: true },
  );
};
